import knight from "./assets/knight.png";
import connect4 from "./assets/connect4.png";
import tetris from "./assets/tetris.png";
import i2048 from "./assets/2048.png";
import pong from "./assets/pong.png";
import snake_game from "./assets/snake_game.png";
import maze_game from "./assets/maze_game.png";
import Card from "./Card";

const games = [
  {
    name: "Connect 4 vs AI",
    description:
      "Try to beat this amazing AI which can play the game of Connect 4",
    image: connect4,
    url: "https://lazycoder16.github.io/connect4-react-mcts/",
  },
  {
    name: "Tetris",
    description: "Stack blocks to break lines and stay low",
    image: tetris,
    url: "https://lazycoder16.github.io/tetris/",
  },
  {
    name: "2048",
    description: "Merge tiles to get the number 2048",
    image: i2048,
    url: "https://lazycoder16.github.io/react-js-2048/",
  },
  {
    name: "Pong",
    description: "Simple game of Atari Pong made in p5.js",
    image: pong,
    url: "https://lazycoder16.github.io/pong-p5js/",
  },
  {
    name: "Snake Game",
    description: "Feed the snake apples to make it as long as possible",
    image: snake_game,
    url: "https://lazycoder16.github.io/snake-game/",
  },
  {
    name: "Maze Game",
    description: "Make me reach the top-left of the grid (my dream)",
    image: maze_game,
    url: "https://lazycoder16.github.io/maze-game/",
  },
];

function renderCards() {
  return games.map((game) => {
    return (
      <Card
        name={game.name}
        image={game.image}
        description={game.description}
        url={game.url}
        key={game.name}
      />
    );
  });
}

function App() {
  return (
    <div className="App">
      <div className="columns is-mobile">
        <div className="column is-narrow">
          <figure className="image is-64x64">
            <img src={knight} alt="logo" className="is-rounded" />
          </figure>
        </div>
        <div className="column">
          <h3 className="title">LazyCoder16 (Abhishek Jain)</h3>
          <h5 className="subtitle">Portfolio for all my games/projects</h5>
        </div>
      </div>

      <div className="is-flex is-flex-wrap-wrap mt-5">{renderCards()}</div>

      <footer className="footer">
        <div className="content">
          Check out my github repositories at{" "}
          <a href="https://github.com/LazyCoder16/">
            https://github.com/LazyCoder16/
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
